import React from 'react';
import { func } from 'prop-types';
import i18n from 'i18next';
import { IconWithText } from 'Components';
import './DownloadPDF.css';

const DownloadPDF = ({ onClick }) => (
  <IconWithText
    text={i18n.t('common:Download PDF')}
    textOrientation="after"
    icon="publish"
    rotate={180}
    onClick={onClick}
  />
);

DownloadPDF.propTypes = {
  onClick: func,
};

export default DownloadPDF;



// WEBPACK FOOTER //
// ./src/components/Actions/DownloadPDF/DownloadPDF.jsx